/* eslint-disable no-console,unicorn/prefer-spread -- no console, unicorn/prefer-spread */
import {
  ApolloClient, InMemoryCache, HttpLink, ApolloLink, from,
} from '@apollo/client';
import uuid from 'uuid/v4';
import { onError } from '@apollo/client/link/error';
import ApolloLinkTimeout from 'apollo-link-timeout';

export const timeoutHttpLink = (graphqlSrc, localeFilename) => {
  const time = localeFilename && localeFilename === 'qa' ? 30e3 : 10e3;
  const timeoutLink = new ApolloLinkTimeout(time);

  return timeoutLink.concat(
    new HttpLink({
      uri: graphqlSrc,
      credentials: 'include',
    })
  );
};

const setHeaders = (path) => new ApolloLink((operation, forward) => {
  /* istanbul ignore next */
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'correlation-id': uuid(),
      'ce-source': path.includes('/banking/') ? 'BANKING' : 'WEB',
    },
  }));

  return forward(operation);
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

const client = (graphqlSrc, locationPath, localeFilename) => new ApolloClient({
  // ssrMode: true,
  defaultOptions,
  connectToDevTools: true,
  link: from([
    onError((errors) => {
      const { graphQLErrors, networkError, operation } = errors;
      const { operationName /* query name */, query, variables } = operation;
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          console.log('application error/ reporting goes here');
          console.log(
            `
            [GraphQL error]: Message: ${message},
            Location: ${JSON.stringify(locations)},
            operationName: ${operationName},
            Path: ${path}
            query: ${JSON.stringify(query)}
            variables: ${JSON.stringify(variables)}
            `
          );
        });
      }
      if (networkError) {
        // all timeout errors logs here. status code is 408
        console.log(
          `[Network error]: ${networkError}. Backend is unreachable. Is it running?`
        );
      }
    }),
    setHeaders(locationPath),
    timeoutHttpLink(graphqlSrc, localeFilename),
  ]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          productAccountByAccountNumberProxy: {
            keyArgs: (args, context) => {
              const { filter: { accountNumberProxy } } = args;
              const { variables: { queryKey } } = context;
              return queryKey || accountNumberProxy;
            },
            merge: true,
          },
        },
      },
    },
  }),
});

export default client;

/* eslint-enable no-console,unicorn/prefer-spread -- enabling for net new integrations */
